import {memo} from 'react';
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useUserContext} from "../../types/contexts/UserContext";

interface FooterProps {
    version: string,
    isOpenOnMobile: boolean
}

const Footer = ({version, isOpenOnMobile}: FooterProps) => {

    const user = useUserContext();

    const documentationLink = user?.user.roles.includes('Admin') ? '/api/documentation/broker' : '/api/documentation/broker';

    return <div
        className={`${isOpenOnMobile ? 'block' : 'hidden'} lg:block w-full bottom-2 absolute left-0 dark:text-gray-500 text-center`}>
        <div className="min-w-[240px] mx-auto flex items-center justify-center">
            {user &&  user.user && user.user.roles.includes('Admin') ? <span className="inline-block text-sm pr-2">
                v{version}
            </span>: ''}
            {user?.user.permissions.includes('see api documentation icon') || user?.user.roles.includes('Admin') ?
                <a href={documentationLink}
                   target="_blank" rel="noreferrer"><FontAwesomeIcon
                    className="text-gray-900 dark:text-gray-500 h-3.5 w-3.5"
                    icon={solid('book')}/></a> : <></>}
        </div>
    </div>;
}

export default memo(Footer);
